import React from 'react';
import styled from 'styled-components';

import { colorsByType, FONT_SIZE } from '@front/common/src/components/alert/constants';
import { alertMessageStyle } from '@front/common/src/components/alert/styles';
import { getMessages } from '@front/common/src/utils/errors';

import Text from '../base-text/base-text';
import type { AlertProps } from './alert';

const Message = styled(Text)`
  ${alertMessageStyle}
`;
const TEXT_FONT_WEIGHT = 400;

const ContentAlert = ({ type, content, centered = false }: Pick<AlertProps, 'type' | 'content' | 'centered'>) => {
  const color = colorsByType[type];

  if (React.isValidElement(content)) return content;

  if (typeof content === 'function') {
    return content({ fontWeight: TEXT_FONT_WEIGHT, fontSize: FONT_SIZE, color });
  }

  // @ts-ignore ReactElement is not correctly narrowed by isValidElement
  const messages = getMessages(content);
  if (Array.isArray(messages) && messages.length > 1) {
    return (
      <>
        {messages.map((m) => (
          <Message
            key={m}
            color={colorsByType[type]}
            fontSize={FONT_SIZE}
            fontWeight={TEXT_FONT_WEIGHT}
            display='block'
            centered={centered}
          >
            {m}
          </Message>
        ))}
      </>
    );
  }
  return (
    <Text fontSize={FONT_SIZE} fontWeight={TEXT_FONT_WEIGHT} color={colorsByType[type]} centered={centered}>
      {Array.isArray(messages) ? messages[0] : messages}
    </Text>
  );
};

export default ContentAlert;
